import axiosInstance from "../config/AuthInterceptors";
import { IBeehiveAlertsBody, IBeehiveAlertsGenericResponse, IBeehiveAlertsGetListResponse } from "../interfaces/beehiveAlerts";

const beehiveAlertsService = {
    getAllGeneric: (skip: number = 0, limit: number = 25) =>
        axiosInstance.get<IBeehiveAlertsGetListResponse>("/beehouses/alerts", {
            params: {
                skip,
                limit
            }
        }).then(res => res.data),
    getAllForBeehive: (beehiveId: string, skip: number = 0, limit: number = 25) =>
        axiosInstance.get<IBeehiveAlertsGetListResponse>("/beehouses/" + beehiveId + "/alerts", {
            params: {
                skip,
                limit
            }
        }).then(res => res.data),
    getOneForBeehive: (beehiveId: string, id: string) => axiosInstance.get<IBeehiveAlertsGenericResponse>("/beehouses/" + beehiveId + "/alerts/" + id).then(res => res.data),
    post: (body: IBeehiveAlertsBody) => axiosInstance.post<IBeehiveAlertsGenericResponse>("/beehouses/read", body).then(res => res.data),
}

export default beehiveAlertsService;